

const openFile = async (url: string): Promise<boolean> => {
  if (!url) {
    console.warn("fileService: URL vacía");
    throw new Error("URL vacía");
  }

  try {
    window.open(url, "_blank", "noopener,noreferrer");

    return true;
  } catch (error) {
    console.error("fileService: Error al abrir archivo", error);
    throw new Error("Error al abrir archivo");
  }
};


const fileService = { openFile };
export default fileService;